import { t } from "@impero-com/common/utils/i18n";
import { queryClient } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";

import { useDeleteTagCategoriesTagCategoryId } from "api/generated/tags/tags";

import { TAGS_QUERY_KEY } from "./useTagsQuery";

export const useDeleteTagCategoryMutation = (
    onDeleted: () => void,
    tagCategoryName: string
) =>
    useDeleteTagCategoriesTagCategoryId({
        mutation: {
            onSuccess: () => {
                emitNotification(
                    "success",
                    t(
                        "TagsList_EditCategoryDrawer_Notification_TagCategoryDeleted",
                        { tagCategoryName }
                    )
                );
                onDeleted();
                queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
            },
            onError: () => {
                emitNotification(
                    "error",
                    t(
                        "TagsList_EditCategoryDrawer_Notification_DeleteTagCategoryFailed"
                    )
                );
            },
        },
    });
